import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { FileServerModel } from '../models/file-server.model';
import { ConfigurationService } from '../shared/services/configuration.service';

@Injectable({
  providedIn: 'root',
})
export class FileServerService {
  private readonly http = inject(HttpClient);
  private readonly configSvc = inject(ConfigurationService);

  public Clients: string = 'Clients';
  public Collaborators: string = 'Collaborators';
  public Products: string = 'Products';
  public Services: string = 'Services';
  public Tasks: string = 'Tasks';
  public Vehicles: string = 'Vehicles';
  public CompletionForms: string = 'CompletionForms';

  private readonly backUrl;

  constructor() {
    this.backUrl = `${this.configSvc.fileServerApiUrl}api`;
  }

  UploadTaskFile(
    id: string,
    model: FileServerModel,
    controller: string,
    identifier?: string
  ): Observable<any> {
    let groupParam = '';
    if (model.group != null) {
      groupParam = `&group=${model.group}`;
    } else if (identifier != null) {
      groupParam = `&group=${identifier}`;
    }
    let requestUrl = `${this.backUrl}/${controller}/${id}/files?name=${model.name}${groupParam}`;
    return this.http.post(requestUrl, model.formData);
  }

  GetTaskFiles(
    id: string,
    controller: string,
    group?: string
  ): Observable<Array<any>> {
    return this.http.get<Array<any>>(
      `${this.backUrl}/${controller}/${id}/files${group != null ? '?group=' + group : ''}`
    );
  }

  delete(id: string): Observable<any> {
    return this.http.delete(`${this.backUrl}/files/${id}`);
  }
}
